var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dashboards-viewer__card-container" }, [
    _c("div", { staticClass: "dashboards-viewer__card" }, [
      _c("h2", { staticClass: "dashboards-viewer__card-title" }, [
        _vm._v("\n      " + _vm._s(_vm.title) + "\n    ")
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "dashboards-viewer__card-subtitle" }, [
        _vm._v(_vm._s(_vm.indicatorsLabel))
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }